import {SURGICAL_TREATMENT_REQUEST, SURGICAL_TREATMENT_REQUEST_SUCCESS, SURGICAL_TREATMENT_REQUEST_ERROR, BOOK_SURGERY_TREATMENT_REQUEST, BOOK_SURGERY_TREATMENT_REQUEST_SUCCESS, BOOK_SURGERY_TREATMENT_REQUEST_ERROR, CLEAR_DATA_SURGERY_TREATMENT } from './Constants';

export const surgicaltreatmentRequest = (id) => ({
    type: SURGICAL_TREATMENT_REQUEST,
    id : id
});

export const surgicaltreatmentRequestSuccess = (data) => ({
    type: SURGICAL_TREATMENT_REQUEST_SUCCESS,
    data : data
});

export const surgicaltreatmentRequestError = () => ({
    type: SURGICAL_TREATMENT_REQUEST_ERROR
});

export const bookSurgicaltreatmentRequest = (payload) => ({
    type: BOOK_SURGERY_TREATMENT_REQUEST,
    payload : payload
});

export const bookSurgicaltreatmentRequestSuccess = (data) => ({
    type: BOOK_SURGERY_TREATMENT_REQUEST_SUCCESS,
    data : data
});

export const bookSurgicaltreatmentRequestError = () => ({
    type: BOOK_SURGERY_TREATMENT_REQUEST_ERROR
});

export const clearSurgeryData = () => ({
    type : CLEAR_DATA_SURGERY_TREATMENT
});